var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.459 0.395508C6.58398 0.395508 0.958984 6.03054 0.958984 12.9708C0.958984 19.2459 5.53398 24.4542 11.509 25.3955V16.6103H8.33398V12.9708H11.509V10.1972C11.509 7.04711 13.3715 5.31518 16.234 5.31518C17.5965 5.31518 19.0215 5.55364 19.0215 5.55364V8.65353H17.4465C15.8965 8.65353 15.409 9.6199 15.409 10.6114V12.9708H18.884L18.3215 16.6103H15.409V25.3955C18.3545 24.9284 21.0367 23.4195 22.9714 21.141C24.906 18.8626 25.9656 15.9648 25.959 12.9708C25.959 6.03054 20.334 0.395508 13.459 0.395508Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.8bb2b3f9022c5090001599b98affee1b.svg";
export { ForwardRef as ReactComponent };